import { cloneElement, useMemo } from "react";
import { components } from "react-select";
import Form from "react-bootstrap/Form";
import { ReactSelectWrapper } from "../react-select-wrapper/react-select-wrapper";
import styles from "./select-input-filter.less";
import { SelectOption } from "@idw-types/common";
import { Column } from "@tanstack/react-table";

type SelectInputFilterProps<T> = {
    options: Array<SelectOption>;
    column: Column<T, unknown>;
    isMulti?: boolean;
}

const SelectInputElement = (props: any) => {
    return cloneElement(<components.Input {...props} />, { "data-lpignore": "true" });
};

export const SelectInputFilter = <T extends object>(props: SelectInputFilterProps<T>) => {
    const { column, options, isMulti = false } = props;

    const filterValue = column.getFilterValue() as string;
    const placeholderText = column.columnDef.header as string;

    const onChangeFilter = (newValue: SelectOption<Array<SelectOption> | SelectOption>) => {
        if (isMulti && Array.isArray(newValue)) {
            column.setFilterValue(newValue.map(val => val.label) || null);
        } else {
            column.setFilterValue(newValue?.value || null);
        }
    };

    const components = {
        Input: SelectInputElement
    };

    const selectedOption = options.find(option => option.value === filterValue);

    const selectedOptions = useMemo(() => {
        if (isMulti && filterValue) {
            return options.filter(option => filterValue.includes(option.label));
        }

        return [];

    }, [isMulti, filterValue]);

    return (
        <div className={styles.selectInputFilter}>
            <Form.Control
                as={ReactSelectWrapper}
                // @ts-ignore
                custom
                isRequired={false}
                menuPlacement={"auto"}
                classNamePrefix={"react-select"}
                options={options}
                onChange={onChangeFilter as any}
                menuPortalTarget={document.getElementById("react-select-portal")}
                value={isMulti ? selectedOptions : selectedOption as any}
                placeholder={placeholderText}
                isSearchable={true}
                isClearable={true}
                isDisabled={false}
                isMulti={isMulti}
                autocomplete="off"
                components={components}
            />
        </div>
    );
};